module.exports = __webpack_public_path__ + "img/sld_surgearrester.9dcbe894.svg";